export default __webpack_public_path__ + "static/media/Animals-25.1402d6fc.png";